import React from 'react';

import Policies from '@totem/components/surveyV2/policies/Policies';
import PoliciesContainer from '@totem/components/surveyV2/policies/PoliciesContainer';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
const PoliciesPage = () => {
  return (
    <ContentLayout>
      <PoliciesContainer>
        <IBCard isCovered>
          <Policies />
        </IBCard>
      </PoliciesContainer>
    </ContentLayout>
  );
};

export default PoliciesPage;
